/** 来客数の算出ソースバッジ用ラベル (v0.3、来客数の汎用化)
 *  設計: docs/design/v03-visitor-count-generalization.md §5-4 */
export type VisitorCountMethod = 'menu_derive' | 'manual_input' | 'external_sync';

const LABELS: Record<VisitorCountMethod, string> = {
  menu_derive: 'メニュー算出',
  manual_input: '手入力',
  external_sync: '他システム連携',
};

/** null は「対象店舗間で算出方式が混在」を表す (テナント/複数店舗集計時) */
export const visitorCountSourceBadge = (method: VisitorCountMethod | null): string =>
  method ? LABELS[method] : '混在';
